export default __webpack_public_path__ + "static/media/holmasto-logo.c0c9d9f8.svg";